module.exports = __webpack_public_path__ + "649bb331a8e379063c33aa982d8061a6.svg";